import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { CANVAS_PATHNAME } from 'site-modules/shared/constants/co-driver/url';
import { CONCIERGE_PATHNAME } from 'site-modules/canvas/constants/concierge';
import { featureFlags } from 'client/utils/feature-flags';
import { handle404Error } from 'site-modules/shared/utils/errors';

export const routes = [
  {
    path: CANVAS_PATHNAME,
    exact: true,
    page: getLoadablePage((_, store) => {
      const state = store.getState();
      const isMobile = state.mobile;

      if (isMobile) {
        return import(/* webpackChunkName: "chat_canvas_mobile" */ '../pages/canvas-definition-mobile');
      }

      return import(/* webpackChunkName: "chat_canvas_desktop" */ '../pages/canvas-definition-desktop');
    }),
    chunkName: 'chat_canvas',
    resolveLocationInParallelToPagePreload: true,
  },
  {
    path: CONCIERGE_PATHNAME,
    exact: true,
    preload: () => {
      if (!featureFlags.get('concierge')) {
        throw handle404Error({ errorMessage: 'Page is not available' });
      }
      return Promise.resolve();
    },
    page: getLoadablePage((_, store) => {
      const state = store.getState();
      const isMobile = state.mobile;

      if (isMobile) {
        return import(/* webpackChunkName: "concierge_mobile" */ '../pages/concierge-definition-mobile');
      }

      return import(/* webpackChunkName: "concierge_desktop" */ '../pages/concierge-definition-desktop');
    }),
    resolveLocationInParallelToPagePreload: true,
  },
];
